import React, { useState } from 'react';
import TorontoFooter from '../Layout/TorontoFooter';
import { Fragment } from 'react';
import "./account.css"
import UserView from './UserView';
import { isLoggedIn } from '../../utils/localStorage';

const AccountPage = ({}) => {
    return (
        <Fragment>
            <div className='accountPage'>
                <div className='infoBanner'>Manage your profile and create bookings only with the Autzu app.</div>
                <div className='accountContainer'>
                    <div className='accountTitle'>
                        Profile
                    </div>
                    { isLoggedIn()?
                        <div className='accountBody'>
                            <img 
                                src='https://autzu-media-kit.s3.ca-central-1.amazonaws.com/logos/autzu-logo1.png'
                                className='accountPicture'/>

                                <UserView/>
                        </div>
                        :
                    <div className='loggedOutProfileText'><a href='./login'>Log in</a>&nbsp;to use the profile page</div>}
                </div>
                <TorontoFooter/>
            </div>
        </Fragment>
    )
}

export default AccountPage;


// WEBPACK FOOTER //
// ./src/components/Account/index.js